import React from 'react'

import { ChevronRight, Archive } from 'lucide-react'
import { getDevToolIcon } from '@/components/utils/taskCreationUtils'
import type { DevTool } from '@/components/dashboard/roadmap/DevToolSelect'

interface ActionButtonsProps {
  onSendToDevTool: (e: React.MouseEvent) => void
  onArchive: (e: React.MouseEvent) => void
  devTool: DevTool
  variant?: 'default' | 'compact'
  isArchived?: boolean
}

const ActionButtons = ({
  onSendToDevTool,
  onArchive,
  devTool,
  variant = 'default',
  isArchived = false,
}: ActionButtonsProps) => {
  const capitalizedDevTool = devTool.charAt(0).toUpperCase() + devTool.slice(1)

  if (variant === 'compact') {
    return (
      <div className="flex items-center gap-2">
        <button
          onClick={onSendToDevTool}
          className="font-manrope flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-[#40424A] dark:text-gray-300 hover:bg-white dark:hover:bg-gray-800 hover:shadow-[0_4px_22px_rgba(15,21,55,0.05)] hover:border-[#40424A] dark:hover:border-gray-600 rounded-md border border-gray-200 dark:border-gray-700 transition-all duration-200"
        >
          <img src={getDevToolIcon(devTool)} alt={devTool} className="h-3 w-auto" />
          Send
        </button>

        <button
          onClick={onArchive}
          className="font-manrope flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-gray-500 dark:text-gray-400 hover:bg-white dark:hover:bg-gray-800 hover:shadow-[0_4px_22px_rgba(15,21,55,0.05)] hover:border-gray-400 dark:hover:border-gray-600 rounded-md border border-gray-200 dark:border-gray-700 transition-all duration-200"
        >
          {isArchived ? 'Restore' : 'Archive'}
        </button>
      </div>
    )
  }

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={onSendToDevTool}
        className="font-manrope flex-1 flex items-center justify-center gap-2 px-4 py-1.5 text-sm font-medium text-[#40424A] dark:text-gray-300 hover:bg-white dark:hover:bg-gray-800 hover:shadow-[0_4px_22px_rgba(15,21,55,0.05)] hover:border-[#40424A] dark:hover:border-gray-600 rounded-lg border border-gray-200 dark:border-gray-700 transition-all duration-200"
      >
        <img src={getDevToolIcon(devTool)} alt={devTool} className="h-3.5 w-auto" />
        Send to {capitalizedDevTool}
        <ChevronRight className="w-4 h-4 text-[#40424A] dark:text-gray-300" />
      </button>

      <button
        onClick={onArchive}
        className="font-manrope flex items-center justify-center gap-1.5 px-4 py-1.5 text-sm font-medium text-gray-500 dark:text-gray-400 hover:bg-white dark:hover:bg-gray-800 hover:shadow-[0_4px_22px_rgba(15,21,55,0.05)] hover:border-gray-400 dark:hover:border-gray-600 rounded-lg border border-gray-200 dark:border-gray-700 transition-all duration-200"
      >
        {isArchived ? 'Restore' : 'Archive'}
      </button>
    </div>
  )
}

export default ActionButtons
